<template lang="html">
  <div>
    <div v-show="error">
      <!-- Error -->
      <p class="alert alert-danger">Error: {{ errorMessage }}</p>
    </div>
    <div>
      <!-- No error. -->
      <b-row v-if="file_obj">
        <b-col md="6">
          <ZipPlayer
            v-if="file_obj && !error"
            :key="'zip' + zipName"
            :zip="file_obj"
            @loaded="loaded"
            @error="onError"
          />
        </b-col>
        <b-col>
          <div v-if="enabled">
            <h3>{{ zipShowInfo.title }}</h3>
            <p>Slides: {{ zipShowInfo.slide_count }}</p>
            <p v-if="zipShowInfo.duration > 1">
              Duration: {{ (zipShowInfo.duration * 1000) | toMMSS }}
            </p>
            <b-button
              size="lg"
              variant="primary"
              :disabled="!enabled"
              @click="beginUpload"
            >
              Begin upload
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import ZipPlayer from "@/components/ZipPlayer/ZipPlayer";
export default {
  name: "ZipPreview",
  components: {
    ZipPlayer
  },
  filters: {
    toMMSS: function(s) {
      // Pad to 2 or 3 digits, default is 2
      function pad(n, z) {
        z = z || 2;
        return ("00" + n).slice(-z);
      }

      var ms = s % 1000;
      s = (s - ms) / 1000;
      var secs = s % 60;
      s = (s - secs) / 60;
      var mins = s % 60;

      return pad(mins) + ":" + pad(secs);
    }
  },
  props: {
    file_obj: {
      type: Blob,
      default: () => {}
    },
    callback: {
      type: Function,
      default: function() {}
    }
  },
  data() {
    return {
      enabled: true,
      error: false,
      errorMessage: "",
      zipShowInfo: {},
      zipShow: {}
    };
  },
  computed: {},
  watch: {
    file_obj: {
      handler(value) {
        if (value) {
          this.enabled = false;
          this.error = false;
          this.zipName = value.name;
        }
      },
      immediate: true
    }
  },
  methods: {
    loaded(obj) {
      console.log("loaded", obj.info);
      this.error = false;
      this.enabled = true;
      this.zipShowInfo = obj.info;
      this.zipShow = obj;
    },
    onError(msg) {
      console.log("onError", msg);
      this.error = true;
      this.errorMessage = msg;
      this.enabled = false;
    },
    beginUpload() {
      this.callback(this.zipShowInfo, this.zipShow);
      this.enabled = false;
    }
  }
};
</script>

<style lang="css" scoped></style>
